import classNames from "classnames";
import { getParentChildSkillsMap } from "PFApp/helpers/get_parent_child_skills_map";
import { useSkillsType } from "PFCore/hooks/use_skills_type";
import { useTranslation } from "react-i18next";

import { MatchCustomFieldSection } from "../../components/match_attribute_section/match_custom_field_section";
import { useEssentialSkills } from "../../hooks/use_essential_skills";
import { useRequiredSkills } from "../../hooks/use_required_skills";
import { useSupportingSkills } from "../../hooks/use_supporting_skills";
import { useMatchCardContext } from "../../match_card_context";
import css from "./match_activity_skills.module.scss";

type MatchActivitySkillsProps = {
  className?: string;
};

export const MatchActivitySkills = ({ className }: MatchActivitySkillsProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.matches.card" });
  const skillsType = useSkillsType();
  const { roleSkills: roleRequiredSkills, matchSkills: matchRequiredSkills } = useRequiredSkills();
  const { roleSkills: roleEssentialSkills, matchSkills: matchEssentialSkills } = useEssentialSkills();
  const { roleSkills: roleSupportingSkills, matchSkills: matchSupportingSkills } = useSupportingSkills();
  const { customValues } = useMatchCardContext();
  const { parentChildMap } = getParentChildSkillsMap({ customValues });

  const renderData = [
    {
      key: "essential",
      matchSkills: matchEssentialSkills,
      roleSkills: roleEssentialSkills,
      customFieldLabel: t("essentialSkills")
    },
    {
      key: "supporting",
      matchSkills: matchSupportingSkills,
      roleSkills: roleSupportingSkills,
      customFieldLabel: t("supportingSkills")
    },
    {
      key: "required",
      matchSkills: matchRequiredSkills,
      roleSkills: roleRequiredSkills,
      customFieldLabel: t("requiredSkills")
    }
  ].filter(({ roleSkills }) => !!roleSkills.length);

  if (renderData.length === 0) {
    return null;
  }

  return (
    <div className={classNames(css.skillsContainer, className)}>
      {renderData.map(({ key, matchSkills, roleSkills, customFieldLabel }) => (
        <MatchCustomFieldSection
          key={key}
          customFieldId={skillsType!.id}
          customFieldLabel={customFieldLabel}
          customFieldName="skills"
          i18nKey="customFieldCount"
          matchCustomValues={matchSkills}
          roleCustomValues={roleSkills}
          parentChildMap={parentChildMap}
        />
      ))}
    </div>
  );
};
